import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import { useScrollToTop } from './hooks/useScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';

// Import only existing service pages
import ReseauInformatique from './pages/services/ReseauInformatique';
import Electricite from './pages/services/Electricite';
import Sonorisation from './pages/services/Sonorisation';

// Import service pages
import FibreOptique from './pages/services/FibreOptique';
import BatimentsElectricite from './pages/services/BatimentsElectricite';
import PostesTransformation from './pages/services/PostesTransformation';
import GtcGtb from './pages/services/GtcGtb';
import Precablage from './pages/services/Precablage';
import ControleAcces from './pages/services/ControleAcces';
import Videosurveillance from './pages/services/Videosurveillance';
import DetectionIncendie from './pages/services/DetectionIncendie';
import Climatisation from './pages/services/Climatisation';

const MainContent = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  useScrollToTop();

  return (
    <main className="flex-grow">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<div className="pt-28"><Services /></div>} />
        <Route path="/contact" element={<div className="pt-28"><Contact /></div>} />
        
        {/* Service routes - only include existing pages */}
        <Route path="/services/reseau" element={<div className="pt-28"><ReseauInformatique /></div>} />
        <Route path="/services/electricite" element={<div className="pt-28"><Electricite /></div>} />
        <Route path="/services/sonorisation" element={<div className="pt-28"><Sonorisation /></div>} />
        <Route path="/services/fibre" element={<div className="pt-28"><FibreOptique /></div>} />
        <Route path="/services/batiments" element={<div className="pt-28"><BatimentsElectricite /></div>} />
        <Route path="/services/transformation" element={<div className="pt-28"><PostesTransformation /></div>} />
        <Route path="/services/gtc" element={<div className="pt-28"><GtcGtb /></div>} />
        <Route path="/services/precablage" element={<div className="pt-28"><Precablage /></div>} />
        <Route path="/services/controle" element={<div className="pt-28"><ControleAcces /></div>} />
        <Route path="/services/video" element={<div className="pt-28"><Videosurveillance /></div>} />
        <Route path="/services/incendie" element={<div className="pt-28"><DetectionIncendie /></div>} />
        <Route path="/services/climatisation" element={<div className="pt-28"><Climatisation /></div>} />
      </Routes>
    </main>
  );
};

function App() {
  return (
    <Router>
      <ErrorBoundary>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <MainContent />
          <Footer />
        </div>
      </ErrorBoundary>
    </Router>
  );
}

export default App;